import GraphObject from './graphObject.js';
import Utils from './utils.js';

/*****************************************************************************/
export const STICKY_TYPE = '___sticky___';

export const STICKY_COLORS = [
	new BABYLON.Color3(75/255, 192/255, 192/255, 0.5),
	new BABYLON.Color3(255/255, 192/255, 75/255, 0.5),
	new BABYLON.Color3(54/255, 162/255, 235/255, 0.5),
	new BABYLON.Color3(255/255, 99/255, 132/255, 0.5),
	new BABYLON.Color3(153/255, 102/255, 255/255, 0.5),
	new BABYLON.Color3(255/255, 159/255, 64/255, 0.5),
	new BABYLON.Color3(0/255, 99/255, 132/255, 0.5),
	new BABYLON.Color3(54/255, 0/255, 235/255, 0.5),
	new BABYLON.Color3(255/255, 206/255, 0/255, 0.5),
];
let iCurrColor = 1;
/*****************************************************************************/
export default class Sticky extends GraphObject
{
	constructor(pParent)
	{
		super(pParent);

		this.vecSize = new BABYLON.Vector2(300, 300);

		this.color = STICKY_COLORS[iCurrColor].clone();
		///iCurrColor = (iCurrColor + 1) % STICKY_COLORS.length;

		this.name = '';
		this.text = '';
	}

	getType()
	{
		return STICKY_TYPE;
	}

	getLabel()
	{
		return this.name;
	}

	setSize(fW, fH)
	{
		if(fW < 80)
			fW = 80;
		if(fH < 80)
			fH = 80;
		this.vecSize.x = fW;
		this.vecSize.y = fH;
	}

	getSize()
	{
		return this.vecSize.clone();
	}

	getColor()
	{
		return this.color;
	}

	getColorAsString(fOpacity = 1.0, fValue = undefined, fSat = undefined)
	{
		return Utils.getColorAsString(this.color, fOpacity, fValue, fSat);
	}

	setColor(fR, fG, fB)
	{
		this.color.r = fR;
		this.color.g = fG;
		this.color.b = fB;
	}

	getText()
	{
		return this.text;
	}

	setText(strValue)
	{
		this.text = strValue;
	}

	saveToObject()
	{
		let pRes = super.saveToObject();
		pRes['color'] = { r: this.color.r, g: this.color.g, b: this.color.b };
		pRes['size'] = { x: this.vecSize.x, y: this.vecSize.y };
		pRes['type'] = STICKY_TYPE;

		pRes['text'] = this.text;

		return pRes;
	}

	static loadFromObject(pObj, pParent)
	{
		let pSticky = pParent.createStickyRaw();

		GraphObject.loadFromObject(pObj, pSticky);

		pSticky.vecSize.x = pObj['size'].x;
		pSticky.vecSize.y = pObj['size'].y;

		pSticky.color.r = pObj['color'].r;
		pSticky.color.g = pObj['color'].g;
		pSticky.color.b = pObj['color'].b;

		pSticky.text = pObj['text'];

		return pSticky;
	}
}